import { c as _c } from "react/compiler-runtime";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
export default function GroupCardActionFooter(t0) {
  const $ = _c(9);
  const {
    loading,
    disabled,
    onSave,
    onCancel
  } = t0;
  let t1;
  if ($[0] !== onCancel) {
    t1 = <button type="button" onClick={onCancel} className="tw-inline-flex tw-items-center tw-justify-center tw-gap-x-2 tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-800 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-iron-200 tw-ring-1 tw-ring-iron-700 tw-shadow-sm tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-bg-iron-700 desktop-hover:hover:tw-border-iron-700 desktop-hover:hover:tw-text-white focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-700">Cancel</button>;
    $[0] = onCancel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== disabled || $[3] !== loading || $[4] !== onSave) {
    t2 = <PrimaryButton loading={loading} disabled={disabled} onClicked={onSave}>Grant</PrimaryButton>;
    $[2] = disabled;
    $[3] = loading;
    $[4] = onSave;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="tw-mt-auto tw-border-t tw-border-white/10 tw-pt-4"><div className="tw-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-3">{t1}{t2}</div></div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}